import { Empty } from '../shared/components/Common';
import { formatPrice } from '../shared/currency/currencyStore';

export function SupplierSearchStatus({ loading, error, offers, suppliersWithErrors }) {
  if (loading) {
    return <div className="api-message" role="status">Searching live supplier inventory…</div>;
  }
  if (error) {
    return (
      <div className="api-message error" role="alert">
        <b>Live search is unavailable.</b> {error.message}
      </div>
    );
  }
  if (!offers.length) {
    return <Empty text="No live offers were returned by the connected suppliers." />;
  }
  return suppliersWithErrors.length > 0 && (
    <div className="api-message warning" role="status">
      Some suppliers could not be reached: {suppliersWithErrors.join(', ')}. Prices shown are from the suppliers that responded.
    </div>
  );
}

export function offerDetail(offer, ...keys) {
  const details = offer.details || {};
  const entries = Object.entries(details);
  for (const key of keys) {
    const found = entries.find(([name]) => name.toLowerCase() === key.toLowerCase());
    if (found && found[1]) return String(found[1]);
  }
  return '';
}

export function formatOfferPrice(offer) {
  // INR supplier prices follow the customer's display currency like the rest of the site.
  if (!offer.currency || offer.currency === 'INR') return formatPrice(offer.totalPrice);
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: offer.currency || 'INR',
      maximumFractionDigits: 0,
    }).format(offer.totalPrice);
  } catch {
    return `${offer.currency || ''} ${Number(offer.totalPrice).toLocaleString('en-IN')}`.trim();
  }
}
